import React from 'react';
import { useTranslation } from 'react-i18next';
import { XCircle } from 'lucide-react';

interface Props {
  failReason: string | null;
}

/**
 * Terminal-failure card rendered in place of the recruitment stepper when
 * the courier was disqualified at the initial-review stage on Monday.
 */
const RecruitmentRejectionCard: React.FC<Props> = ({ failReason }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-start gap-4 rounded-xl border border-haat-red-200 bg-haat-red-50 p-5 sm:p-6">
      <div className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-white text-haat-red-700">
        <XCircle size={24} />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-bold text-haat-red-900">
          {t('portal.stage.disqualifiedTitle')}
        </h3>
        {failReason ? (
          <div className="mt-2">
            <p className="text-xs font-semibold uppercase tracking-wider text-haat-red-700">
              {t('portal.stage.failReasonLabel')}
            </p>
            <p className="mt-1 text-sm font-medium text-haat-red-900">{failReason}</p>
          </div>
        ) : (
          <p className="mt-2 text-sm text-haat-red-800">
            {t('portal.stage.disqualifiedNoReason')}
          </p>
        )}
      </div>
    </div>
  );
};

export default RecruitmentRejectionCard;
